jQuery(function ($) {
  var isPc = $(window).width() > 769
  var isMobileBind = false

  $('.selectList select').each(function() {
    $(this).change(function () {
      var label = $(this).find(':selected').text()
      $(this).siblings('.selected').text(label)
    })
  })
  $('.btnTab').click(function () {
    var target = $(this).data('target')
    if (!$(this).hasClass('on')) {
      $(this).addClass('on').siblings().removeClass('on')
      $(target).show().siblings().hide()
    }
  })
  $('.tabSelect').change(function () {
    var target = $(this).val()
    $(target).show().siblings().hide()
  })
  $('.btnDropdown').click(function () {
    $(this).parent().siblings('.depth').find('.on').hide().removeClass('on')
    $(this).siblings('.linkList').toggleClass('on').slideToggle(200)
    $('.generateList ul').hide()
  })
  $('.line-clamp').each(function (index, item) {
    new MultiClamp(item, {
      ellipsis: '...',
      clamp: 2
    })
  })
  var btn
  $.fn.modalHandler = function (bool, target) {
    // console.log(bool, target)
    if (bool) {
      btn = $(this)
      $(target).show()
      $(target).find('.btnClose').focus()
      var winH = $(window).height()
      var domH = $(target).find('.modal').height()
      if (winH > domH+265) {
        $(target).removeClass('fit')
      } else {
        $(target).addClass('fit')
      }
    } else {
      btn.focus()
      btn = null
      $(target).hide()
      $(target).removeClass('fit')
    }
  }
  navHandler()
  generateList()

  $('.generateList .selected').click(function () {
    $('.linkList.on').hide().removeClass('on')
    $(this).siblings('ul').slideToggle(200)
  })
  $(document).on('click','.generateList li button', function () {
    var label = $(this).text()
    var value = null
    var select = $(this).parents('ul').siblings('select')
    $(this).parents('ul').slideUp(200)
    select.find('option').each(function () {
      if ($(this).text() === label) {
        value = $(this).val()
      }
    })
    $(this).parents('ul').siblings('.selected').text(label)
    select.val(value)
  })
  $(document).mouseup( function (e) {
    if (!$('.generateList').is(e.target) && $('.generateList').has(e.target).length === 0) {
      $('.generateList ul').hide()
    }
    if (!$('.depth').is(e.target) && $('.depth').has(e.target).length === 0) {
      $('.linkList.on').hide().removeClass('on')
    }
  })

  function generateList() {
    $('.generateList').each(function () {
      $(this).find('select').css('z-index', -1)
      var list = []
      $(this).find('option').each(function () {
        list.push($(this).text())
      })
      $(this).append('<ul></ul>')
      for (var i = 0; i < list.length; i++) {
        $(this).find('ul').append('<li><button>'+list[i]+'</button></li>')
      }
    })
  }
  function navHandler() {
    if (isPc) {
      $('.navWrap').removeClass('open')
      var initNavHeight = $('.navWrap').height()
      $('.navWrap').hover(function () {
        $(this).toggleClass('on')
      })
      $('.navWrap').bind('mouseenter focusin', function() {
        $(this).addClass('on')
      })
      $('.navWrap').bind('mouseleave focusout', function() {
        $(this).removeClass('on')
      })
    } else {
      $('.navWrap').removeClass('on')
      $('.navWrap').unbind()
      if (!isMobileBind) {
        isMobileBind = true
        $('.btnNavOpen').click(function () {
          $('.navWrap').addClass('open')
        })
        $('.btnNavClose').click(function () {
          $('.navWrap').removeClass('open')
          $('.depth1.open').removeClass('open')
        })
        $('.btnMToggle').click(function (e) {
          e.preventDefault()
          $(this).parent().siblings('.open').removeClass('open')
          $(this).parent().toggleClass('open')
        })
      }
    }
  }
  $( window ).resize(function() {
    var isPcNew = $(window).width() > 769
    if (isPc !== isPcNew) {
      isPc = isPcNew
      navHandler()
    }
  })
})
